import { PolicyInformation } from '../models';

export function getDeductionsFromExcessString(
  excess: string,
  isRepair: boolean
): Pick<
  PolicyInformation,
  | 'repairDeductible'
  | 'replacementDeductible'
  | 'repairRateDeductible'
  | 'replacementRateDeductible'
> {
  const resultDeductions: ReturnType<typeof getDeductionsFromExcessString> = {};

  const excessNumValue = parseInt(excess?.match(/\d+/)?.[0]);
  const isPercentage = !!excess?.match(/%/)?.[0];

  if (isPercentage) {
    if (isRepair) {
      resultDeductions.repairRateDeductible = excessNumValue;
    } else {
      resultDeductions.replacementRateDeductible = excessNumValue;
    }
  } else {
    if (isRepair) {
      resultDeductions.repairDeductible = excessNumValue;
    } else {
      resultDeductions.replacementDeductible = excessNumValue;
    }
  }

  return resultDeductions;
}
